<template>
<div>
<div class="container">
    <TopPanel />
    <div><h1>Pricing</h1></div>
 <div class="pricing-container">
    <div class="card-grid"> 
        <div  v-for="card in cards" :key="card.id" class="price-card">
            <h1>{{card.plan}}</h1>
            <p>{{card.description}}</p>
            <h2>${{card.price}}</h2>
            <button class="submit-button">Buy Now</button>
            <hr class="feature-divider">
            <div class="features" v-for="(feature,idx) in card.features" :key="idx">
                    <div ><span class="pi pi-check mr-2"></span> {{feature}}</div>
            </div>
        </div>
    </div>
 </div>
 </div>
</div>
</template>




<script>
import TopPanel from './TopPanel.vue'; 
// import {ref} from 'vue'
export default {

data() {
return{
cards : [
    {
    id:1,
    plan:'Pro',
    description:'Suitable for students and hobbyists',
    price:25,
    features:[
        '5 Data Analytics Courses',
        '10 Quizzes',
        'Certificate of Completion',
        'Interview Questions',
        'Bonus Lessons',
        'Real Life Projects'

    ]
    
    },
    {
    id:2,
    plan:'Premium',
    description:'Suitable for working professionals',
    price:39,
    features:[
        '5 Data Analytics Courses',
        '10 Quizzes',
        'Certificate of Completion',
        'Interview Questions',
        'Bonus Lessons',
        'Real Life Projects'

    ]
    },
  {
    id:2,
    plan:'Business',
    description:'Suitable for training teams in enterprises',
    price:139,
    features:[
        '5 Data Analytics Courses',
        '10 Quizzes',
        'Certificate of Completion',
        'Interview Questions',
        'Bonus Lessons',
        'Real Life Projects'

    ]
    },

]
}
},

components: {
   TopPanel,
   
  },


}
</script>





<style scoped>

.container{
background: #1a1625;
color:whitesmoke;
}


.pricing-container{
display: flex;
justify-content: center;
align-items: center;

}

.card-grid{
padding-top:3vw;
display: flex;
/* grid-template-columns: repeat(auto-fill, minmax(600px, 1fr)); */
align-items: center;
justify-content: center;
gap: 20px;
}


.price-card {
border: 1px solid gray;
width:210px;
border-radius: 5px ;
height: 500px;
margin: auto 0;
padding: 18px;
text-align: center;
transition: transform 0.3s ease, box-shadow 0.3s ease;
background:  #2f2b3a;   

}

.price-card:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}


.features{
    text-align: left;
    padding:10px;
    font-size:13px;
}

.submit-button {
  width: 86%;
  padding: 10px;
  margin-top:8px;
  margin-bottom: 20px;
  background-color: #ffff99;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
  font-size: 14px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode';
}

/* .submit-button{
  width:86%;
  background-color: #ffff99;
  color: #001233;
  border: 1px solid #8f9ba3;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
} */


.submit-button:hover {
  background-color: #d5d58b;
}

.feature-divider{
 /* background-color: red; */
 border-color: gray; 
 max-width: 84%;
 margin-left: 8%;
 margin-bottom: 35px;
 margin-top: 3%;
}


/* .card-grid{
  flex-grow: 1;
  display: grid;
  grid-template-rows: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px; 
  padding: 16px; 
  margin-top: 10px;
} */


@media only screen and (max-width: 800px) {

.price-card {
width:200px;
}
.card-grid{
display: grid;
grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
align-items: center;
/* gap: 20px; */
}

}
</style>